// libs
import { PluginKey } from 'prosemirror-state';

export const EMOJI_OPEN_REGEX = /:(\w+)?$/;

export const EMOJI_CONTAINER_ID = 'reaction-plugin';
export const EMOJI_CONTAINER_SELECTOR = `#${EMOJI_CONTAINER_ID}`;

export const EMOJI_PLUGIN_KEY = new PluginKey(EMOJI_CONTAINER_ID);

export const EVENT_KEYS = ['ArrowUp', 'ArrowDown', 'Enter', 'Escape'];
